import { render, staticRenderFns } from "./CandidatesHandleFailedBody.vue?vue&type=template&id=b46ba296&lang=pug"
import script from "./CandidatesHandleFailedBody.vue?vue&type=script&lang=js"
export * from "./CandidatesHandleFailedBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports